// export const baseurl='http://localhost:5001'
// export const WEBSITE_URL='http://localhost:3001'
// export const baseurl = 'http://13.205.147.130:5000';
export const baseurl = 'https://db.mensaindia.org/api';
export const WEBSITE_URL='https://mensaindia.org'
